export default "__VITE_ASSET__BLy$Ns6q__"